<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <b-card>
      <b-card-title class="d-flex justify-content-between">
        <div>
          <img
            class="card-icon"
            style="margin-right: 16px"
            :src="require('@/assets/icons/plant.svg')"
            alt="plant"
          >
          <router-link :to="`/fields/${fieldId}/blocks/${blockId}`">
            <span
              v-if="!isLoadingBlock"
              title="Lihat block detail"
              class="my-auto text-capitalize"
            >
              {{ blockDetail.name }}
            </span>
            <Skeleton
              v-else
              height="15px"
              width="10rem"
            />
          </router-link>
        </div>
        <b-button
          v-if="!isLoadingBlock"
          class="d-none d-md-block"
          variant="primary"
          size="sm"
          @click="addPeriod"
        >
          Tambah Periode Tanam
        </b-button>
        <Skeleton
          v-else
          height="1.7rem"
          width="10rem"
        />
        <PeriodForm
          id="modal-form-period"
          :block-detail="blockDetail"
          :period-detail="periodDetail"
          @reload-data="updateData"
          @update-data="makeToast"
        />
      </b-card-title>

      <b-card-sub-title style="margin-left: 40px; margin-bottom: 16px">
        <span v-if="!isLoadingBlock">Periode Tanam ({{ blockPeriods.length }})</span>
        <Skeleton
          v-else
          height="0.9rem"
          width="7rem"
        />
      </b-card-sub-title>
      <b-button
        v-if="!isLoadingBlock"
        class="ms-auto d-block mb-3 d-md-none"
        variant="primary"
        size="sm"
        @click="addPeriod"
      >
        Tambah Periode Tanam
      </b-button>

      <div
        v-if="!isLoadingPeriod && blockPeriods.length === 0"
        class="d-flex justify-content-center my-3"
      >
        Sorry, there is no history yet.
      </div>

      <template v-if="isLoadingPeriod">
        <div
          v-for="item in 2"
          :key="item"
          class="border border-light p-3 mt-3"
        >
          <div class="d-flex gap-4 float-md-end mb-4">
            <Skeleton
              v-for="item in 3"
              :key="item"
              width="5rem"
              height="2.3rem"
            />
          </div>
          <h4 class="card-title mb-4">
            <Skeleton
              width="150px"
              height="15px"
            />
          </h4>
          <Skeleton
            v-for="item in 7"
            :key="item"
            class="mb-3"
            height="12px"
            width="240px"
          />
        </div>
      </template>
      <div
        v-for="(period, index) in blockPeriods"
        v-else
        :key="index"
        class="accordion"
        style="border-bottom: 1px solid #C4C4C4;"
        role="tablist"
      >
        <b-card
          class="mb-0"
          no-body
        >
          <b-card-header
            v-b-toggle="'period-'+ index"
            header-tag="header"
            class="d-flex accordion-toggle justify-content-between shadow-none pt-3"
            :class="{ 'active-accordion': !index }"
            style="padding-left: 40px"
            role="tab"
          >
            Periode Tanam #{{ blockPeriods.length - index }}
            <i class="mdi mdi-chevron-down" />
            <i class="mdi mdi-chevron-up" />
          </b-card-header>
          <b-collapse
            :id="'period-'+ index"
            accordion="my-accordion"
            role="tabpanel"
            style="margin-left: 40px;"
          >
            <b-card-body style=" padding-left: 0px">
              <div class="d-none d-md-flex gap-4 float-md-end mb-3">
                <b-button
                  variant="outline-primary"
                  class="d-none"
                >
                  <div class="d-flex">
                    <i class="mdi mdi-download-outline" />
                    <div class="d-none d-md-inline ms-1">
                      Unduh Resume
                    </div>
                  </div>
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="editPeriod(period)"
                >
                  <div class="d-flex">
                    <i class="mdi mdi-pencil-outline" />
                    <div class="d-none d-md-inline ms-1">
                      Edit
                    </div>
                  </div>
                </b-button>
                <b-button
                  variant="outline-danger"
                  @click="deletePeriod(period,index)"
                >
                  <div class="d-flex">
                    <i class="mdi mdi-trash-can-outline" />
                    <div class="d-none d-md-inline ms-1">
                      Delete
                    </div>
                  </div>
                </b-button>
              </div>
              <table class="table-text mb-3">
                <tbody>
                  <tr
                    v-for="detail in getPeriodData(period)"
                    :key="detail.label"
                  >
                    <td>{{ detail.label }}</td>
                    <td>:</td>
                    <td>{{ detail.value }} {{ detail.unit }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="d-flex d-md-none gap-4 justify-content-between mb-3">
                <b-button
                  variant="outline-primary"
                  class="d-none"
                >
                  <div class="d-flex">
                    <i class="mdi mdi-download-outline" />
                    <div class="d-none d-md-inline ms-1">
                      Unduh Resume
                    </div>
                  </div>
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="editPeriod(period)"
                >
                  <div class="d-flex">
                    <i class="mdi mdi-pencil-outline" />
                    <div class="ms-1">
                      Edit
                    </div>
                  </div>
                </b-button>
                <b-button
                  variant="outline-danger"
                  @click="deletePeriod(period,index)"
                >
                  <div class="d-flex">
                    <i class="mdi mdi-trash-can-outline" />
                    <div class="ms-1">
                      Delete
                    </div>
                  </div>
                </b-button>
              </div>
              <div>
                <b-card-header
                  v-b-toggle="'chart-'+ index"
                  header-tag="header"
                  class="d-flex accordion-toggle justify-content-center shadow-none active-accordion"
                  role="tab"
                  @click="getPayload(period, index)"
                >
                  Show chart
                  <div class="ps-2">
                    <i class="mdi mdi-chevron-down" />
                    <i class="mdi mdi-chevron-up" />
                  </div>
                </b-card-header>
                <b-collapse
                  :id="'chart-'+ index"
                  class="mt-2"
                >
                  <template v-if="period.payloads">
                    <div
                      v-for="payloadKey in selectedPayloads"
                      :key="payloadKey"
                    >
                      <hr>
                      <div class="mb-3 fw-bold">
                        {{ getPayloadName(payloadKey) }}
                      </div>
                      <ChartCard
                        :payload-key="payloadKey"
                        :timewindow="timewindow"
                        :payloads="period.payloads"
                      />
                    </div>
                  </template>
                  <div
                    v-else
                    :ref="'chart-'+ index"
                    class="text-center d-none"
                  >
                    Sorry, there is no chart yet
                  </div>
                </b-collapse>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </b-card>
  </Layout>
</template>

<style>
.accordion-toggle {
  cursor: pointer;
}

.accordion-toggle:hover {
  opacity: 0.9;
  background-color: #EEF1FD;
}

header.not-collapsed {
  background-color: #EEF1FD;
  color: #556EE6;
}

header.collapsed {
  background-color: #FFFFFF;
}

header.active-accordion {
  background-color: #EEF1FD !important;
  color: #556EE6;
}

header[aria-expanded=true] .mdi-chevron-down {
   display: none;
}
header[aria-expanded=false] .mdi-chevron-up {
   display: none;
}

.Vue-Toastification__toast--success {
  background: #D6F3E9;
  color: #195E45;
  padding: 8px 16px;
  display: flex;
  border: #34C38F 1px solid;
  border-radius: 8px;
}

.Vue-Toastification__toast {
  min-height: 30px;
}

.Vue-Toastification__toast-body {
  margin-top: auto;
  margin-bottom: auto;
  max-height: 32px;
  margin-left: 0.5rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}
.Vue-Toastification__icon {
  margin: auto;
  font-size: 16px;
  height: 24px !important;
}
.Vue-Toastification__close-button {
  color: #195E45;
  margin: auto;
  height: 24px !important;
}

@media (min-width: 991.98px) {
  .Vue-Toastification__container {
      margin-top: 120px !important;
  }
}

@media (max-width: 991.98px) {
  .Vue-Toastification__container {
      margin-top: 80px !important;
  }
}
</style>

<script>
import { POSITION } from 'vue-toastification';
import appConfig from '@/app.config';
import PageHeader from '@/components/page-header';
import Skeleton from '@/components/Skeleton';
import Layout from '@/layouts/main';
import {
  highlightString, formatDateTime, formatDate, parsePayloadKey, plantCategories, formatNumber,
} from '@/utils/helper';
import PeriodForm from './PeriodForm';
import ChartCard from '@/components/ChartCard';
import uplinkPayloads from '@/compositions/uplink-payload';
import axiosToken from '@/compositions/axios-token';

export default {
  page: {
    title: 'History',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    PeriodForm,
    Skeleton,
    ChartCard,
  },
  data() {
    return {
      title: 'History',
      blockDetail: {},
      periodDetail: {},
      blockPeriods: [],
      currentPage: 1,
      perPage: 10,
      isLoadingBlock: false,
      isLoadingPeriod: false,
      filter: {
        page: 1,
      },
      selectedPayloads: ['soil_vmc', 'soil_wt1', 'soil_wt2'],
      deviceType: 'sensor_soil',
      timewindow: {},
    };
  },
  computed: {
    items() {
      return [
        {
          text: 'Reservoir List',
          to: '/history',
        },
        {
          text: 'Petak List',
          to: `/history/${this.fieldId}`,
        },
        {
          text: "Petak's History",
          active: true,
        },
      ];
    },
    blockId() {
      return this.$route.params.blockId;
    },
    fieldId() {
      return this.blockDetail.field?.id;
    },
    deviceDetail() {
      // get sensor soil device of this block
      return this.blockDetail.devices.find((device) => device.type === this.deviceType) || {};
    },
  },
  created() {
    this.getBlockDetail();
    this.getBlockPeriods();
  },
  methods: {
    highlightString,
    makeToast(text) {
      this.$toast(`${text} successfully.`, {
        type: 'success',
        position: POSITION.TOP_CENTER,
        icon: {
          iconClass: 'mdi mdi-check-circle',
          iconTag: 'i',
        },
      });
    },
    updateData() {
      this.getBlockDetail();
      this.getBlockPeriods();
    },
    async getBlockDetail() {
      try {
        this.isLoadingBlock = true;
        const { data } = await this.$api.getBlockDetail(this.blockId, {
          load_last_period: true,
        });
        this.blockDetail = data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingBlock = false;
      }
    },
    async getBlockPeriods({ page = 1 } = {}) {
      try {
        this.isLoadingPeriod = true;
        const { data } = await this.$api.getBlockPeriods(this.blockId, {
          page,
        });
        this.blockPeriods = data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingPeriod = false;
      }
    },
    editPeriod(period) {
      this.periodDetail = period;
      this.$bvModal.show('modal-form-period');
    },
    addPeriod() {
      this.periodDetail = {};
      this.$bvModal.show('modal-form-period');
    },
    downloadPeriod(period) {
      alert('download cooming soon');
    },
    async deletePeriod(period, index) {
      const confirmationModal = this.$bvModal.msgBoxConfirm('Apakah anda yakin ingin menghapus periode tanam ini?', {
        title: `Hapus Periode Tanam #${this.blockPeriods.length - index}`,
        size: 'sm',
        okVariant: 'danger',
        cancelVariant: 'outline-secondary',
        okTitle: 'OK',
        cancelTitle: 'Batal',
        centered: true,
      });
      if (!await confirmationModal) {
        return;
      }
      try {
        const response = await this.$api.deleteBlockPeriod(this.blockId, period.id);
        this.updateData();
        if (response.status === 204) { this.makeToast('Deleted'); }
      } catch (error) {
        console.log(error);
      }
    },
    getPeriodData(period) {
      return [
        {
          key: 'area',
          label: 'Luas Tanam',
          value: formatNumber(period.area),
          unit: 'ha',
        },
        {
          key: 'start_date',
          label: 'Tanggal Tanam',
          value: formatDate(period.start_date),
        },
        {
          key: 'end_date',
          label: 'Tanggal Panen',
          value: formatDate(period.end_date),
        },
        {
          key: 'plant_category',
          label: 'Kategori',
          value: plantCategories[period.plant_category],
        },
        {
          key: 'yield',
          label: 'Hasil Panen',
          value: formatNumber(period.yield || 0),
          unit: 'ton',
        },
        {
          key: 'productivity',
          label: 'Produktivitas Lahan',
          value: formatNumber((Number(period.yield || 0) / Number(period.area || 0)).toFixed(2)),
          unit: 'ton/ha',
        },
        {
          key: 'consumption',
          label: 'Total Pemakaian Air',
          value: '-', // formatNumber('xxx'),
        },
        {
          key: 'last_update',
          label: 'Last Update',
          value: formatDateTime(period.updated_at),
        },
      ];
    },
    async getPayload(period, index) {
      const { start_date, end_date, id } = period;
      const { device_id } = this.deviceDetail;
      if (!start_date || !end_date) {
        this.$refs[`chart-${index}`][0].classList.remove('d-none');
        return;
      }
      if (!device_id) {
        this.$refs[`chart-${index}`][0].classList.remove('d-none');
        return;
      }

      // set timewindow for chart component
      this.timewindow = {
        start_date,
        end_date,
        type: 'month',
      };

      const payloadObject = await this.getUplinkPayloads({
        start_date,
        end_date,
        device_id,
      });

      // populate payloads and payloadMeta to period object
      this.blockPeriods = this.blockPeriods.map((item) => (+item.id === +id ? { ...item, ...payloadObject } : item));
    },
    async getUplinkPayloads({
      start_date, end_date, device_id, page = 1,
    }) {
      const { token, cancelRequest } = axiosToken.generate();
      // this.cancelRequest = cancelRequest;

      const { payloads, payloadMeta } = await uplinkPayloads.get({
        start_date, end_date, device_id, page, token,
      });

      return { payloads, payloadMeta };
    },
    getPayloadName(payloadKey) {
      const { name } = parsePayloadKey(payloadKey);
      return name;
    },
  },
};
</script>
